import { lazy } from 'react'

import { ROUTES } from './paths'

// Lazy load pages
const ErrorPage = lazy(() => import('@/pages/ErrorPage'))
const FirstTimeVisitPage = lazy(() => import('@/pages/FirstTimeVisitPage'))
const GuestPage = lazy(() => import('@/pages/GuestPage'))
const GamePage = lazy(() => import('@/pages/GamePage'))
const HomePage = lazy(() => import('@/pages/HomePage'))
const CouponsPage = lazy(() => import('@/pages/CouponsPage'))
const DashboardBrandPage = lazy(() => import('@/pages/DashboardBrandPage'))
const DashboardPage = lazy(() => import('@/pages/DashboardPage'))
const MarketingConsentsPage = lazy(
  () => import('@/pages/MarketingConsentsPage')
)
const NotFoundPage = lazy(() => import('@/pages/NotFoundPage'))
const NotAvailablePage = lazy(() => import('@/pages/NotAvailablePage'))
const LotteryPage = lazy(() => import('@/pages/LotteryPage'))

// Dev-only pages
const SandboxPage = lazy(() => import('@/pages/SandboxPage'))
const SandboxLoaderPage = lazy(() => import('@/pages/SandboxPage/LoaderPage'))
const DevelopmentLoginPage = lazy(() => import('@/pages/DevLoginPage'))

export interface RouteConfig {
  path: string
  component: React.ComponentType
  title?: string
  children?: RouteConfig[]
}

const baseRoutes: RouteConfig[] = [
  {
    path: ROUTES.HOME,
    component: HomePage,
    title: 'Accueil',
  },
  {
    path: ROUTES.GAME,
    component: GamePage,
    title: 'Jeu',
  },
  {
    path: ROUTES.NOT_FOUND,
    component: NotFoundPage,
    title: 'Page non trouvée',
  },
  {
    path: ROUTES.ERROR,
    component: ErrorPage,
    title: 'Erreur',
  },
  {
    path: ROUTES.GUEST,
    component: GuestPage,
    title: 'Bienvenue',
  },
  {
    path: ROUTES.FIRST_TIME_VISIT,
    component: FirstTimeVisitPage,
    title: 'Bienvenue',
  },
  {
    path: ROUTES.MARKETING_CONSENTS,
    component: MarketingConsentsPage,
    title: 'Consentements',
  },
  {
    path: ROUTES.COUPONS,
    component: CouponsPage,
    title: 'Mes Cadeaux',
  },
  {
    path: ROUTES.DASHBOARD,
    component: DashboardPage,
    title: 'Dashboard',
  },
  {
    path: ROUTES.DASHBOARD_BRAND,
    component: DashboardBrandPage,
    title: 'Dashboard',
  },
  {
    path: ROUTES.NOT_AVAILABLE,
    component: NotAvailablePage,
    title: 'Not Available',
  },
  {
    path: ROUTES.LOTTERY,
    component: LotteryPage,
    title: 'Loterie',
  },
]

declare const __DEPLOY__: string

// Check if we're in dev environment (local dev server or dev deployment)
// eslint-disable-next-line unicorn/prevent-abbreviations
const isDevEnvironment = import.meta.env.DEV || __DEPLOY__ === 'dev'

// Dev-only routes (excluded from stage and production)
const devRoutes: RouteConfig[] = isDevEnvironment
  ? [
      {
        path: ROUTES.SANDBOX,
        component: SandboxPage,
        title: 'Sandbox',
        children: [{ path: 'loader', component: SandboxLoaderPage }],
      },
      {
        path: ROUTES.DEV_LOGIN,
        component: DevelopmentLoginPage,
        title: 'Dev Login',
      },
    ]
  : []

export const routes: RouteConfig[] = [...baseRoutes, ...devRoutes]
